<template>
    <div>
        <div class="row">
            <div class="col-md-12 col-12 cyor_box mb-4">
                <picture>
                    <source media="(min-width: 768px)" width="1788" height="382" type="image/webp" srcset="~/assets/landing/loose/cyo/cyor.webp">
                    <source media="(min-width: 768px)" width="1788" height="382" type="image/jpeg" srcset="~/assets/landing/loose/cyo/cyor.jpg">

                    <source media="(max-width: 992px)" width="944" height="500" type="image/webp" srcset="~/assets/landing/loose/cyo/cyor_mob.webp">
                    <source media="(max-width: 992px)" width="944" height="500" type="image/jpeg" srcset="~/assets/landing/loose/cyo/cyor_mob.jpg">
                    <!-- <source media="(max-width: 992px)" width="944" height="500"  srcset="~/assets/landing/loose/cyo/cyor_mob.webp"> -->
                    <img class="radious_eight" alt="Create Your Own Engagement Ring" loading="lazy" width="1788" height="382" type="image/jpeg" src="~/assets/landing/loose/cyo/cyor.jpg">
                </picture>
                <div key="1" class="cyor_upper cyor_upper_one radius_mod" v-if="page === 'loose'">
                    <h4 class="font-active">Create Your Own <br> Engagement Ring</h4>
                    <p>Design your custom engagement ring for a truly unique style. </p>
                    <NuxtLink class="anker radious_four" :to="localePath({ name:'cyo-setting-list-ring'})">Start with a Ring Setting</NuxtLink>
                </div>
                <div key="2" class="cyor_upper cyor_upper_one radius_mod" v-if="page === 'wedding'">
                    <h4 class="font-active">Create Your Own <br> Diamond Ring</h4>
                    <p>Design brilliance, the way you like!</p>
                    <NuxtLink class="anker radious_four" :to="localePath({ name:'cyo-setting-list-ring'})">Start with a Ring Setting</NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath();
    const props = defineProps({
    page: String,
    })
</script>

<style scoped>

.cyor_box {
    position: relative;
}
.cyor_upper_one {
    position: absolute;
    top: 50%;
    left: 74%;
    transform: translate(-50%, -50%);
    width: 30%;
    text-align: left;
}


.cyor_upper h4 {
    font-size: 32px;
    color: #fff;
}
.cyor_upper p {
    padding: 0;
    color: #fff;
}
a{
    display: inline-block;
    font-size: 13px;
    color: #fff;
    border: 1px solid #fff;
    text-transform: uppercase;
    font-weight: 600;
    padding: 8px 15px;
}
@media(max-width: 1500px){
    
    
}
@media(max-width: 1300px){
    .cyor_upper h4{
        font-size: 28px;
    }
 
}
@media(max-width: 1130px){
    .cyor_upper h4{
        font-size: 22px;
    }
    .cyor_upper p{
        font-size: 14px;
    }
    
}
@media(max-width: 992px){
    .cyor_upper h4,    .cyor_upper p{
        color: #000;
    }
    a{
        border-color: #000;
        color: #000;
    }
    .cyor_upper_one{
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        width: 100%;
        text-align: center;
        padding: 5%;
        background: #f2e3da;
    }
    
    .cyor_upper h4 br{
        display:none;
    }
    a{
        padding: 7px 14px;

    }
    .cyor_upper h4{
        font-size: 24px
    }
    .cyor_upper p{
        font-size: 16px
    }
    .radious_eight {
        border-radius: 8px 8px 0 0;
    }
    .radius_mod {
        border-radius: 0 0 8px 8px;
    }
  
}

@media(max-width:767px){
    
    .cyor_upper h4{
        font-size: 24px
    }
    .cyor_upper p{
        font-size: 14px
    }
   
    a{
        color: #000;
        border-color: #000;
        padding: 10px 20px;
       
    }
    .col-12{
        padding: 0;
    }
}
@media(max-width:500px) {
    .radious_eight {
        border-radius: 0;
    }
    .radius_mod {
        border-radius: 0;
    }
}
</style>
